import { FC } from 'react';
import Previews from './Previews';
import Sheet from './Sheet';
import PathBreadcrumbs from '@screens/Books/Book/components/Breadcrumbs/PathBreadcrumbs';
import { GridContentMaxWidth } from '@screens/Books/Book/Nodes/Previews/Contents';
import { MARGIN_BEFORE_FOOTER } from '@styles/consts';
import { useBookSheetSlugs } from '@utils/hooks/useBookSlugs';

const Nodes: FC = () => {
    const { sheetId } = useBookSheetSlugs();

    return (
        <>
            {sheetId ? <Sheet /> : <Previews />}
            <PathBreadcrumbs
                sx={{
                    maxWidth: sheetId ? '100%' : GridContentMaxWidth,
                    mt: MARGIN_BEFORE_FOOTER,
                }}
            />
        </>
    );
};

export default Nodes;
